// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cf0f4423","977":"7f1b775f"}[chunkId] + ".chunk.js";
};